import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { I18nService } from './services/i18n/i18n.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  constructor(private readonly _i18nService: I18nService) {}
}
